<template>
    <van-form class="default-form" ref="exportProduct" @submit="handleSummit" :show-error="false"
              input-align="right" error-message-align="right">

        <van-field placeholder="请选择商品税则号" v-model="exportProduct.hsCode" readonly @click="hsCodeSelect"
                   label="商品税则号" class="van-field-required van-field-border" :rules="rules.hsCodeRule">
            <i slot="extra" class="van-icon-arrow van-cell__right-icon van-icon"></i>
        </van-field>

        <van-field label="货物描述" placeholder="请输入货物描述" type="textarea" v-model="exportProduct.description"
                   :rules="rules.descriptionRule" rows="1" autosize
                   class="van-field-border van-field-required" clearable></van-field>


        <van-field placeholder="请输入商品数量" label="数量" v-model="exportProduct.quantity" type="number"
                   :rules="rules.quantityRule" clearable class="van-field-border van-field-required">
        </van-field>

        <van-field label="单位" placeholder="请选择商品单位" v-model="exportProduct.unitLabel" :rules="rules.unitRule"
                   readonly @click="unitVisible = true" class="van-field-border van-field-required">
            <i slot="extra" class="van-icon-arrow van-cell__right-icon van-icon"></i>
        </van-field>

        <van-field placeholder="选择单位后自动填充" v-model="exportProduct.unitsLabel" :rules="rules.unitsRule"
                   class="van-field-border van-field-required" readonly>
            <span slot="label">复数单位<i class="extra-cont">自动填充</i> </span>
        </van-field>

        <van-field placeholder="请输入单价" label="单价" v-model="exportProduct.unitPrice" :rules="rules.unitPriceRule"
                   clearable type="number" class="van-field-border van-field-required"></van-field>

        <van-field placeholder="请输入金额" label="金额" v-model="exportProduct.amount" :rules="rules.amountRule"
                   clearable type="number" class="van-field-border van-field-required"></van-field>

        <van-field placeholder="请输入包装数量" label="包装数量" v-model="exportProduct.packageQuantity"
                   :rules="rules.packageQuantityRule" type="number" clearable
                   class="van-field-border van-field-required"></van-field>

        <van-field placeholder="请选择包装单位" label="包装单位" v-model="exportProduct.packageUnitLabel"
                   :rules="rules.packageUnitRule" readonly
                   @click="packageUnitVisible = true" class="van-field-border van-field-required">
            <i slot="extra" class="van-icon-arrow van-cell__right-icon van-icon"></i>
        </van-field>

        <van-field placeholder="FOB金额必须以美元计" label="商品FOB价格(美元)" v-model="exportProduct.fobValue"
                   :rules="rules.fobValueRule" type="number" class="van-field-border van-field-required"
                   label-width="auto" clearable></van-field>

        <van-field placeholder="请输入第一法定数量" label="第一法定数量" v-model="exportProduct.theFirstOfficialQuantity"
                   clearable type="number"
                   :rules="rules.firstQuantityRule" class="van-field-border van-field-required"></van-field>

        <van-field placeholder="请选择第一法定单位" label="第一法定单位" v-model="exportProduct.theFirstOfficialUnitLabel"
                   :rules="rules.firstUnitRule" readonly
                   @click="theFirstOfficialUnitVisible = true" class="van-field-border van-field-required">
            <i slot="extra" class="van-icon-arrow van-cell__right-icon van-icon"></i>
        </van-field>

        <van-field placeholder="请输入第二法定数量" label="第二法定数量" v-model="exportProduct.theSecondOfficialQuantity"
                   type="number" :rules="rules.secondQuantityRule" class="van-field-border" clearable></van-field>

        <van-field placeholder="请选择第二法定单位" label="第二法定单位" v-model="exportProduct.theSecondOfficialUnitLabel"
                   readonly @click="theSecondOfficialUnitVisible = true" class="van-field-border">
            <i slot="extra" class="van-icon-arrow van-cell__right-icon van-icon"></i>
        </van-field>

        <van-field placeholder="请输入净重" label="净重" v-model="exportProduct.netWeightQuantity" clearable type="number"
                   :rules="rules.weightRule" class="van-field-border"></van-field>

        <van-field placeholder="请选择净重单位" label="净重单位" v-model="exportProduct.netWeightUnitLabel" readonly
                   @click="netWeightUnitVisible = true" class="van-field-border">
            <i slot="extra" class="van-icon-arrow van-cell__right-icon van-icon"></i>
        </van-field>

        <van-field placeholder="请输入毛重" label="毛重" v-model="exportProduct.grossWeight" clearable
                   :rules="rules.grossWeightRule" class="van-field-border"></van-field>

        <van-field placeholder="请选择毛重单位" label="毛重单位" v-model="exportProduct.grossWeightUnitLabel" readonly
                   @click="grossWeightUnitVisible = true" class="van-field-border"></van-field>

        <van-field label="文字唛头" placeholder="请输入文字唛头" type="textarea" v-model="exportProduct.mark"
                   :rules="rules.mark" class="van-field-border van-field-required" :rows="1" autosize clearable></van-field>

        <van-field v-if="checkBulk(region.value)" label="是否散装货" label-width="auto"
                   input-align="right" error-message-align="right">
          <template #input>
            <van-switch v-model="exportProduct.isBulk" size="20px"></van-switch>
          </template>
        </van-field>

        <van-row type="flex" class="form-footer">
            <van-row type="flex">
                <i class="form-footer-save-add"></i>
                <van-button native-type="button" @click="handleCancel">取消</van-button>
            </van-row>
            <van-row type="flex">
                <i class="form-footer-save"></i>
                <van-button native-type="submit">保存</van-button>
            </van-row>
        </van-row>

        <!--税则号选择-->
        <van-popup v-model="hsCodeVisible" position="bottom">
            <common-picker @close="hsCodeVisible = false" @confirm="hsCodeConfirm"
                           :columns="hsCodeOptions"></common-picker>
        </van-popup>

        <!--单位选择-->
        <van-popup v-model="unitVisible" position="bottom">
            <common-picker @close="unitVisible = false" @confirm="unitConfirm" :columns="unitOptions"></common-picker>
        </van-popup>

        <!--包装单位选择-->
        <van-popup v-model="packageUnitVisible" position="bottom">
            <common-picker @close="packageUnitVisible = false" @confirm="packageUnitConfirm"
                           :columns="packageUnitOptions"></common-picker>
        </van-popup>

        <!--法定第一单位选择-->
        <van-popup v-model="theFirstOfficialUnitVisible" position="bottom">
            <common-picker @close="theFirstOfficialUnitVisible = false" @confirm="theFirstOfficialUnitConfirm"
                           :columns="officialUnitOptions"></common-picker>
        </van-popup>

        <!--法定第二单位选择-->
        <van-popup v-model="theSecondOfficialUnitVisible" position="bottom">
            <common-picker @close="theSecondOfficialUnitVisible = false" @confirm="theSecondOfficialUnitConfirm"
                           :columns="officialUnitOptions"></common-picker>
        </van-popup>

        <!--净重单位选择-->
        <van-popup v-model="netWeightUnitVisible" position="bottom">
            <common-picker @close="netWeightUnitVisible = false" @confirm="netWeightUnitConfirm"
                           :columns="unitsOptions"></common-picker>
        </van-popup>

        <!--毛重单位选择-->
        <van-popup v-model="grossWeightUnitVisible" position="bottom">
            <common-picker @close="grossWeightUnitVisible = false" @confirm="grossWeightUnitConfirm"
                           :columns="unitsOptions"></common-picker>
        </van-popup>

    </van-form>
</template>

<script>
    import {eventBus, noticeManager} from "@zhoujianhui/vip-core"
    import ExportProduct from '../../../origin-certificate/dto/ExportProduct'
    import CommonPicker from '../../../component/CommonPicker'
    import dictionaryService from "../../../component/dictionary-service";
    import filingService from "../../../product-filing/service/filing-service";
    import certificateService from "../../../origin-certificate/service/certificate-service";
    import originCertificateRegion from "../../../origin-certificate/service/origin-certificate-region";
    import OriginCountryDecisionDto from "../../../origin-certificate/dto/OriginCountryDecisionDto";

    export default {
        name: "PrefExportProduct",
        props: {
            region: Object,
            exportInvoiceList: Array,
            transportList: Object,
        },
        components: {
            CommonPicker
        },
        data() {
            return {
                hsCodeVisible: false,
                invoiceNumVisible: false,
                countryVisible: false,
                unitVisible: false,
                packageUnitVisible: false,
                theFirstOfficialUnitVisible: false,
                theSecondOfficialUnitVisible: false,
                netWeightUnitVisible: false,
                grossWeightUnitVisible: false,

                exportProduct: new ExportProduct(),
                rules: ExportProduct.getRules(),

                hsCodeOptions: [],
                countryOptions: [],
                unitOptions: [],
                unitsOptions: [],
                packageUnitOptions: [],
                officialUnitOptions: []
            }
        },
        created() {
            this.loadUnitOptions();
            this.loadDictionaryOptions();
        },
        computed: {
            exportInvoiceOptions() {
                return this.exportInvoiceList
                    .map(item => {
                        return {
                            value: item.num,
                            label: item.num,
                        }
                    });
            }
        },
        methods: {
            /**
             * Description 查询单位(数量单位、毛重单位、净重单位)字典
             * Date 2022/5/5
             */
            async loadUnitOptions() {
                let result = await certificateService.getUnitDictionary();
                if (result.isSuccess()) {
                    this.unitOptions = result.data
                        .map(item => {
                            return {
                                value: item.singularUnit,
                                label: item.singularUnit,
                            }
                        });
                    this.unitsOptions = result.data
                        .map(item => {
                            return {
                                value: item.pluralUnit,
                                label: item.pluralUnit
                            }
                        });
                } else {
                    noticeManager.showMessage(result.msg, result.type);
                }
            },
            /**
             * Description 查询单位(国家、包装单位、法定第二单位)字典
             * Date 2022/5/5
             */
            async loadDictionaryOptions() {
                const result = await dictionaryService.getDictionaryIncludeItemsByIds([11, 12, 14]);
                if (result.isSuccess()) {
                    this.countryOptions = result.data.find(item => item.id == 11).items.filter(item => item.enabled);
                    this.packageUnitOptions = result.data.find(item => item.id == 12).items.filter(item => item.enabled);
                    this.officialUnitOptions = result.data.find(item => item.id == 14).items.filter(item => item.enabled)
                        .map(item => {
                            return {
                                value: item.value,
                                label: item.label + "(" + item.value + ")"
                            }
                        });
                }
            },
            async hsCodeSelect() {
                const result = await filingService.searchProductFilingListUnPaged();
                if (result.isSuccess()) {
                    this.hsCodeOptions = result.data.content.map(item => {
                        return {
                            value: item.id,
                            label: item.hsCode
                        }
                    });
                    if (this.hsCodeOptions.length === 0) {
                        this.$message.error('未找到商品税则号,请先进行商品备案');
                    }else {
                        this.hsCodeVisible = true;
                    }
                }
            },
            hsCodeConfirm(exportProductSelected) {
                this.exportProduct.productFilingId = exportProductSelected.value;
                this.exportProduct.hsCode = exportProductSelected.label;
                this.hsCodeVisible = false;
            },
            showHsCodeSelect(){
                this.hsCodeVisible = true;
            },
            async invoiceNumSelect() {
                if (this.exportInvoiceOptions.length <= 0) {
                    noticeManager.showMessage("请先添加发票", "error");
                    return false;
                } else {
                    this.invoiceNumVisible = true;
                }
            },
            invoiceNumConfirm(selectedInvoice) {
                this.exportProduct.invoiceNum = selectedInvoice.value;
                this.invoiceNumVisible = false;
            },
            countryConfirm(selectedCountry) {
                this.exportProduct.countryId = selectedCountry.value;
                this.exportProduct.countryLabel = selectedCountry.label;
                this.countryVisible = false;
            },
            unitConfirm(selectedUnit) {
                this.exportProduct.unit = selectedUnit.value;
                this.exportProduct.unitLabel = selectedUnit.label;
                const selectedUnits = this.unitsOptions.find(item => item.value.replace("S(", "(") === selectedUnit.value);
                this.exportProduct.units = selectedUnits.value;
                this.exportProduct.unitsLabel = selectedUnits.label;
                this.unitVisible = false;
            },
            packageUnitConfirm(selectedPackageUnit) {
                this.exportProduct.packageUnit = selectedPackageUnit.value;
                this.exportProduct.packageUnitLabel = selectedPackageUnit.label;
                this.packageUnitVisible = false;
            },
            theFirstOfficialUnitConfirm(selectedOfficialUnit) {
                this.exportProduct.theFirstOfficialUnit = selectedOfficialUnit.value;
                this.exportProduct.theFirstOfficialUnitLabel = selectedOfficialUnit.label;
                this.theFirstOfficialUnitVisible = false;
            },
            theSecondOfficialUnitConfirm(selectedOfficialUnit) {
                this.exportProduct.theSecondOfficialUnit = selectedOfficialUnit.value;
                this.exportProduct.theSecondOfficialUnitLabel = selectedOfficialUnit.label;
                this.theSecondOfficialUnitVisible = false;
            },
            netWeightUnitConfirm(selectedUnits) {
                this.exportProduct.netWeightUnit = selectedUnits.value;
                this.exportProduct.netWeightUnitLabel = selectedUnits.label;
                this.netWeightUnitVisible = false;
            },
            grossWeightUnitConfirm(selectedUnits) {
                this.exportProduct.grossWeightUnit = selectedUnits.value;
                this.exportProduct.grossWeightUnitLabel = selectedUnits.label;
                this.grossWeightUnitVisible = false;
            },
            async originCountryDecide() {//智能判定原产国
                if (this.transportList) {//校验运输路线
                    const originCountryDecisionDto = OriginCountryDecisionDto.buildOriginCountryDecisionDto(this.exportProduct, this.transportList);
                    if (OriginCountryDecisionDto.checkFields(originCountryDecisionDto)) {//校验必输字段
                        let result = await certificateService.originCountryDecide(originCountryDecisionDto);
                        if (result.isSuccess()) {
                            if (result.data.tariffDiffState === "FINISH") {
                                result.data.originCountryLevel != null ? this.exportProduct.countryId = result.data.originCountry + result.data.originCountryLevel : this.exportProduct.countryId = result.data.originCountry;
                            }
                            if (result.data.tariffDiffState === "CONFIRM_MICRO_MACHINING") {
                                this.minVisible = true;
                            }
                        } else {
                            noticeManager.showMessage(result.msg, result.type);
                        }
                    }
                }
            },
            async microConfirm() {//微小确认智能判定原产国
                let result = await certificateService.microConfirm();
                if (result.isSuccess()) {
                    if (result.data.tariffDiffState === "FINISH") {
                        result.data.originCountryLevel != null ? this.exportProduct.countryId = result.data.originCountry + result.data.originCountryLevel : this.exportProduct.countryId = result.data.originCountry;
                        this.minVisible = false;
                    }
                } else {
                    noticeManager.showMessage(result.msg, result.type);
                }
            },
            checkBulk(value) {
              return originCertificateRegion.checkBulk(value)
            },
            validate() {
                return this.$refs["exportProduct"].validate().then(() => {
                    return new Promise(resolve => resolve(true))
                }).catch(() => {
                        return new Promise(resolve => resolve(false))
                    }
                )
            },
            handleCancel() {
                this.$emit('close');
            },
            handleSummit() {
                eventBus.$emit('addExportProduct', this.exportProduct);
                this.$emit('close');
            }
        }
    }
</script>

